(ns app.front.view.group.admin.approval-authority-config
  (:require [app.front.ui.config-pills :as ui-config-pills]
            [app.front.ui.select :as ui-select]
            [app.front.view.group.admin.core :as core]
            [app.front.view.group.admin.subs :as gas]
            [core.front.carbon :as cc]
            [core.front.event :refer [<sub]]
            [core.util.util :as util]
            [potpuri.core :as p]
            [re-frame.core-instrumented :as rf]))

(rf/reg-event-fx ::fetch-stakeholder-groups
  (fn [_ [_ group-id]]
    (let [cmd :approval/stakeholder-groups]
      {:fx [[:dispatch [::core/set-fetching-config group-id cmd]]
            [:comm/command {:command    cmd
                            :method     :get
                            :data       {:auth-group-id group-id}
                            :on-success [::fetch-stakeholders.success group-id cmd]}]]})))


(rf/reg-event-fx ::fetch-stakeholders.success
  (fn [{:keys [db]} [_ group-id command status stakeholders]]
    {:dispatch [::core/config-fetched group-id command status stakeholders]
     :db       (assoc db ::stakeholders stakeholders)}))


(rf/reg-sub ::available-groups
  :<- [::gas/group]
  (fn [group _]
    (->> (concat [group]
                 (:group/authority-delegates group))
         (map #(select-keys % [:db/id :group/name]))
         (sort-by :group/name))))

(rf/reg-sub ::stakeholders
  #(get % ::stakeholders))



(defn authority-select [{:keys [tr *group-config parent-config target]}]
  (let [[parent-authority-id source-config-name] (:group.config/approval-authority parent-config)
        this-authority-id                        (:group.config/approval-authority @*group-config)
        available-groups                         (<sub [::available-groups])
        own-group                                (<sub [::gas/group])]
    (when (> (count available-groups) 1)
      (cc/form-group
        {:legend-text (tr [:group.config/approval-authority])}
        [ui-select/select
         {:id           (str target "/select-approval-authority")
          :hide-label   true
          :class-name   "select-w-full"
          :label-text   (tr [:group.config/approval-authority])
          :helper-text  (if (and parent-authority-id
                                 (not this-authority-id))
                          (tr [:group-admin/disabled-reason] [source-config-name])
                          "")
          :on-change    #(swap! *group-config assoc :group.config/approval-authority %)
          :values       (map :db/id available-groups)
          :value        (or this-authority-id
                            parent-authority-id
                            (:db/id own-group))
          :val->str     #(-> available-groups
                             (p/find-first {:db/id %})
                             :group/name)
          :allow-empty? false}]))))

(rf/reg-sub ::available-approver-groups
  :<- [::stakeholders]
  (fn [groups _]
    (->> groups
         vals
         (sort-by :group/long-name))))

(defn select-by-ids [ids values]
  (filter (comp (set ids) :db/id) values))

(defn select-initial-groups [{:keys [tr target *group-config parent-config]}]
  (let [values       (<sub [::available-approver-groups])
        pre-selected (select-by-ids (:group.config/default-approver-groups parent-config) values)
        selected     (select-by-ids (:group.config/default-approver-groups @*group-config) values)]
    [ui-config-pills/config-pills
     (util/mmap {:legend-text     (tr [:group-admin/default-approver-group])
                 :add-button-text (tr [:group-admin/add-approver-group])
                 :val->str        :group/long-name
                 :remove-item     #(swap! *group-config update :group.config/default-approver-groups
                                          (fn [item]
                                            (remove (fn [id]
                                                      (= id (:db/id %)))
                                                    item)))
                 :add-item        #(swap! *group-config update :group.config/default-approver-groups (comp set conj) (:db/id %))
                 :id              (str target "/select-approver-group")}
                pre-selected selected values tr)]))
